const openable = () => {
    console.log('openable')
    const burger = document.querySelector('._e-Nav__Burger');
    const menu = document.querySelector('._e-Nav__Burger__Menu');

    if (burger) {
        console.log("burger")
        burger.addEventListener('click', function(){
            console.log("wech")
            menu.classList.toggle('show');
            burger.firstElementChild.classList.toggle('fa-bars');
            burger.firstElementChild.classList.toggle('fa-times');
        })
    }
}

openable();
